import {
  Button,
  Icon,
  Tooltip,
  TooltipPopup,
  TooltipTrigger,
} from "@salestrak/ui";

import { useViewsOptional } from "#app/lib/views/view-context";
import { OPTIONS_PANEL_TRIGGER_PROPS } from "./options-panel-slots";

/**
 * The toolbar affordance that opens the view's display options. Renders
 * nothing outside a saved-view scope, so the same toolbar serves the team and
 * member screens unchanged.
 *
 * It TOGGLES. The panel closes on a press anywhere on the page, and this
 * control is on the page: the marker tells the panel to leave this press
 * to the toggle, so it closes once instead of closing and reopening.
 */
export function ViewOptionsTrigger() {
  const views = useViewsOptional();
  if (!views?.activeView) return null;

  return (
    <Tooltip>
      <TooltipTrigger
        render={
          <Button
            aria-label="Customize view"
            size="icon-xs"
            variant="outline"
            shape="pill"
            onClick={() =>
              views.panelOpen ? views.closePanel() : views.openPanel("main", "toolbar")
            }
            {...OPTIONS_PANEL_TRIGGER_PROPS}
          />
        }
      >
        <Icon name="settings" size="sm" />
      </TooltipTrigger>
      <TooltipPopup side="top">Customize your view settings</TooltipPopup>
    </Tooltip>
  );
}

/**
 * The list toolbar's shortcut straight to the panel's Fields page — the
 * "add columns" affordance. Stateless: it reflects nothing, it only opens
 * the panel on that page. Hidden without manage permission, because every
 * control the Fields page holds is disabled without it. Marked like the
 * toggle, so pressing it while the panel is open switches the page instead
 * of closing the panel under the press.
 */
export function ViewFieldsTrigger() {
  const views = useViewsOptional();
  if (!views?.activeView || !views.canManage) return null;

  return (
    <Tooltip>
      <TooltipTrigger
        render={
          <Button
            aria-label="Add columns"
            size="icon-xs"
            variant="ghost"
            onClick={() => views.openPanel("fields", "fields_button")}
            {...OPTIONS_PANEL_TRIGGER_PROPS}
          />
        }
      >
        <Icon name="column-3" size="sm" />
      </TooltipTrigger>
      <TooltipPopup side="top">Add columns to your view</TooltipPopup>
    </Tooltip>
  );
}
